<template lang="pug">
  v-popover(
    :placement='actionsPlacement'
    :delay='{show: 100, hide: 600}'
    trigger='hover click'
    popoverClass='krea-actions-popover'
    :container='false'
    :disabled='noActions'
    @update:open='updateOpen'
  )
    .width-100
      .row.middle(v-if='!subtopics.length || edition')
        simple-svg.m-right-1(:filepath='topicsIcon' width='20px' height='20px')
        subtopics-select(:value='subtopics' @change='updateMethod' @close='closeSelect')
      topics(v-else :subtopics='subtopics')
    template(slot="popover")
      actions(
        :edit='edit'
        :comments='comments'
        :pdf='pdf'
        :link='link'
        :info='info'
        :open='actionsOpen'
        @edit='setEdition(!edition)'
        :placement='actionsPlacement.split("-")[1]'
      )
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway'
import errorIcon from '@/assets/ic_stop.svg'
import inputValidation from '@/mixins/inputsValidationMixin'
import Actions from '@/components/Krea/Inputs/Actions/Actions'
import kreaActions from '@/mixins/kreaActions'
import Topics from '@/components/Krea/Resource/Topics'
import SubtopicsSelect from '@/components/Krea/Resource/SubtopicsSelect'
import topicsIcon from '@/assets/ic_topics.svg'
import { mapActions } from 'vuex'

export default {
  mixins: [ inputValidation, clickaway, kreaActions ],
  components: { Actions, Topics, SubtopicsSelect },
  props: {
    subtopics: { type: Array },
    updateMethod: { type: Function },
    errorMessage: { type: String },
    disabled: { type: Boolean },
    noActions: { type: Boolean }
  },
  data() {
    return {
      topicsIcon,
      errorIcon,
      edition: false,
      loading: false,
      actionsOpen: false
    }
  },
  async created() {
    this.loading = true
    await this.hydrateTopics()
    if (this.value) {
      this.selected = this.value
      this.activeTopics = this.topics
        .filter(top => top.subtopics.filter(sub => this.selected.includes(sub.id)).length)
        .map(top => top.id)
    }
    this.loading = false
  },
  methods: {
    ...mapActions([
      'hydrateTopics'
    ]),
    closeSelect() {
      this.edition = false
    },
    updateOpen(value) {
      this.actionsOpen = value
    },
    setEdition(value) {
      this.edition = value
      if (!this.edition) this.verifyValidation()
      else {
        if (this.$refs.kreaTextInput) this.$refs.kreaTextInput.focus()
      }
    },
    updateInput(event) {
      this.updateMethod(event.target.value.trim(), this.name)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
